'use strict';

const h = require('phy');

const signInComponent = ({ signInMessageText }) => {
  return h(
    '.sign-in-wrapper',
    h('.icon-lock'),
    h('.sign-in', {
      dangerouslySetInnerHTML: { __html: signInMessageText },
    })
  );
};

module.exports = signInComponent;
